import Settings from "../../components/employeer/settings";

const SettingEmployeerPage = () => {
  return <Settings />;
};

export default SettingEmployeerPage;
